import axios from "axios"

const MESSAGE_TIMEOUT = 5 * 1000

export default class GiftCard {
  constructor() {
    this.copyGiftCardLink = document.querySelector(".giftcard-copy")
    this.copiedSuccessMessage = document.querySelector(".giftcard-copied-success")

    this.copyGiftCardLink.addEventListener("click", this.handleClick.bind(this))
  }

  handleClick(event) {
    event.preventDefault()

    const giftCardNumber = document.querySelector(".giftcard-code").value

    navigator.clipboard.writeText(giftCardNumber).then(() => {
      this.copiedSuccessMessage.classList.remove("hidden")

      setTimeout(() => {
        this.copiedSuccessMessage.classList.add("hidden")
      }, MESSAGE_TIMEOUT)
    })
  }
}
